'use client';
import React from 'react';
import { Modal } from 'antd';
import { cn } from '@/utils/common';

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  width?: number;
  title: string;
  children: React.ReactNode;
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  footer?: React.ReactNode | null;
  className?: string;
  headerClassName?: string; // added headerClassName prop
}
export const ModalWrapper: React.FC<ModalWrapperProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer = null,
  width,
  className,
  headerClassName, // destructured headerClassName
}) => {
  const styles = {
    mask: {
      backgroundColor: '#084F9E70',
    },
    body: {
      borderRadius: '0 !important',
    },
  };
  return (
    <Modal
      title={
        <span className={`text-xl text-darkBlue ${headerClassName || ''}`}>
          {title}
        </span>
      } // updated title with headerClassName
      open={isOpen}
      styles={styles}
      onCancel={onClose}
      footer={footer}
      width={width}
      centered
    >
      <div className={cn('scrollbar max-h-[80vh] overflow-y-auto ', className)}>
        {children}
      </div>
    </Modal>
  );
};
